import React from 'react';
import { useTranslation } from 'react-i18next';
import closeButtonPic from '../../assets/designSystem/icons/close.svg';
import Button from '../../components/Inputs/Button';
import './wdim.css';

export default function Wdim({ text, callback }) {
  const { t } = useTranslation();
  return (
    <>
      <div className="modal__backdrop" />
      <div className="modal__popup">
        <div className="wdim__container wdim__fullWidth">
          <img
            src={closeButtonPic}
            alt="close button"
            className="wdim__closeBtn"
            role="presentation"
            width="24"
            onClick={callback}
          />
          <div className="wdim__content">
            <p>{text}</p>
          </div>
          <div className="wdim__button">
            <Button width="fullWidth" hierarchy="primary" onClick={callback}>
              {t('wdim.button')}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
